module.exports = __webpack_public_path__ + "static/img/public-health.8f274c4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/20250724/shuzihua/public-health.jpg
// module id = 3pEj
// module chunks = 1 2